// Elite Light — kategorický color system (VIP / A / B / C)
// Drahokamová metafora: zlato → platina → bronz → standard.
// Použij kdekoli kategorizuješ entity (klienti, projekty, vendoři…).
// Vyžaduje Tailwind CSS. Pro ne-Tailwind projekty použij třídy
// .cat-vip / .cat-a / .cat-b / .cat-c z elite-light-standalone.css.

export const CATEGORY_STYLES = {
    VIP: {
        id: "VIP",
        label: "VIP",
        chip: "bg-gradient-to-br from-amber-400 via-yellow-400 to-orange-500 text-[#FFFFFF] shadow-[0_4px_14px_-4px_rgba(217,119,6,0.5)]",
        ring: "ring-amber-300",
        ringStrong: "ring-amber-400/80",
        ringHex: "#F59E0B",
        accent: "from-amber-400 to-orange-500",
        accentBar: "bg-gradient-to-b from-amber-400 to-orange-500",
        soft: "bg-amber-50 text-amber-800 ring-1 ring-amber-200",
        glow: "shadow-[0_8px_30px_-8px_rgba(245,158,11,0.45)]",
        gradientBanner: "from-amber-300 via-yellow-300 to-orange-400",
        symbol: "★",
    },
    A: {
        id: "A",
        label: "A",
        chip: "bg-gradient-to-br from-slate-300 via-slate-400 to-slate-500 text-[#FFFFFF] shadow-[0_4px_14px_-4px_rgba(71,85,105,0.35)]",
        ring: "ring-slate-300",
        ringStrong: "ring-slate-400/70",
        ringHex: "#94A3B8",
        accent: "from-slate-300 to-slate-500",
        accentBar: "bg-gradient-to-b from-slate-300 to-slate-500",
        soft: "bg-slate-100 text-slate-700 ring-1 ring-slate-200",
        glow: "shadow-[0_8px_30px_-8px_rgba(100,116,139,0.35)]",
        gradientBanner: "from-slate-200 via-slate-300 to-slate-400",
        symbol: "◆",
    },
    B: {
        id: "B",
        label: "B",
        chip: "bg-gradient-to-br from-orange-300 via-amber-500 to-amber-700 text-[#FFFFFF] shadow-[0_4px_14px_-4px_rgba(180,83,9,0.4)]",
        ring: "ring-orange-200",
        ringStrong: "ring-orange-300/70",
        ringHex: "#C2410C",
        accent: "from-orange-300 to-amber-600",
        accentBar: "bg-gradient-to-b from-orange-300 to-amber-600",
        soft: "bg-orange-50 text-orange-800 ring-1 ring-orange-200",
        glow: "shadow-[0_8px_30px_-8px_rgba(194,65,12,0.35)]",
        gradientBanner: "from-orange-200 via-amber-300 to-amber-500",
        symbol: "●",
    },
    C: {
        id: "C",
        label: "C",
        chip: "bg-[var(--surface)] text-[var(--muted)] ring-1 ring-black/10",
        ring: "ring-black/5",
        ringStrong: "ring-black/10",
        ringHex: "#CBD5E1",
        accent: "from-slate-200 to-slate-300",
        accentBar: "bg-gradient-to-b from-slate-200 to-slate-300",
        soft: "bg-[var(--surface-2)] text-[var(--muted)] ring-1 ring-black/5",
        glow: "",
        gradientBanner: "from-slate-100 via-slate-100 to-slate-200",
        symbol: "○",
    },
};

export const CATEGORY_LIST = ["VIP", "A", "B", "C"];

export const getCategory = (item) =>
    CATEGORY_STYLES[item?.category] || CATEGORY_STYLES.C;
